import { useHistory } from 'react-router';

import NoticePage from '../../../../components/templates/NoticePage/NoticePage';
import { useCoreTranslation } from '../../hooks/useCoreTranslation';

import { NOTICEPAGE_TYPE } from '@/components/templates/NoticePage/NoticePage.types';

const AccountPasswordChangeSuccess = () => {
  const history = useHistory();
  const { label } = useCoreTranslation(__filename);

  return (
    <NoticePage
      type={NOTICEPAGE_TYPE.SUCCESS}
      withNavBar={false}
      title={label('Your password has been changed', { textTransform: 'capitalize' })}
      actions={[
        {
          label: label('Go to home', { textTransform: 'capitalize' }),
          action: () => history.push('/'),
        },
      ]}
    />
  );
};

export default AccountPasswordChangeSuccess;
